import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

// Create a theme instance.
export const theme = createTheme({
    palette: {
        primary: {
            main: '#333333',
        },
        secondary: {
            main: '#8B0E04',
        },
        error: {
            main: red.A400,
        },
        background: {
            default: '#fff',
        },
    },
});